var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 37,
    viewBox: "0 0 49 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gmail_2020 1",
    clipPath: "url(#clip0_234_39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 17",
    x: 5,
    width: 39,
    height: 37,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M3.34083 37H11.1367V17.9383L0 9.52917V33.6364C0 34.5284 0.35198 35.384 0.978507 36.0148C1.60504 36.6456 2.45479 37 3.34083 37Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M37.8633 37H45.6592C46.5452 37 47.395 36.6456 48.0215 36.0148C48.648 35.384 49 34.5284 49 33.6364V9.52917L37.8633 17.9383V37Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M37.8633 3.36364V17.9383L49 9.52918V5.04546C49 4.10846 48.7409 3.18997 48.2516 2.3929C47.7623 1.59584 47.0623 0.951705 46.2299 0.532665C45.3975 0.113626 44.4656 -0.0637585 43.5387 0.0203895C42.6118 0.104537 41.7265 0.446893 40.982 1.00909L37.8633 3.36364Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1367 17.9383V3.36365L24.5 13.4546L37.8633 3.36365V17.9383L24.5 28.0292L11.1367 17.9383Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M0 5.04543V9.52915L11.1367 17.9382V3.36361L8.018 1.00906C7.27348 0.446862 6.38818 0.104507 5.46129 0.020359C4.5344 -0.063789 3.60255 0.113595 2.77015 0.532635C1.93775 0.951674 1.2377 1.59581 0.748426 2.39287C0.259155 3.18993 0 4.10843 0 5.04543Z",
    fill: "#C5221F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 37,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.ef7bc176ce7f3ccadb2f3f93508b8d37.svg";
export { ForwardRef as ReactComponent };